import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { LoginService } from '../../login';
import { ErrorHandlerService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
var MyConnectionsComponent = /** @class */ (function () {
    function MyConnectionsComponent(data, dashboardService, errorHandlerService, loginService, route, router, confirmationService) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.loginService = loginService;
        this.route = route;
        this.router = router;
        this.confirmationService = confirmationService;
        this.user = {};
        this.query = {};
        this.uid = {};
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.myConnection = [];
        this.eduInstresults = [];
        this.connectionfilter = {};
        this.isOnlyMyConnectionsRequired = 'false';
        this.countries = [];
        this.sendMsg = false;
        this.viewProfile = {};
        this.msgData = {};
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.usersummaryDone = false;
        this.countriesDone = false;
        this.myConnectionsDone = false;
        this.searchDone = false;
        //console.log(this.data.storage.myconnection.userid);
    }
    MyConnectionsComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.showSpinner = true;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        var s1 = this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) {
            _this.reqRcmd.userRequestText = '';
            _this.request = false;
            _this.showSpinner = false;
            _this.createInfoAlert("Recommendation Request sent successfully !!");
        }, function (error) {
            _this.request = false;
            _this.reqRcmd.userRequestText = '';
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    MyConnectionsComponent.prototype.cancelsendM = function () {
        this.sendMsg = false;
    };
    MyConnectionsComponent.prototype.sendInvite = function (id, searchResult) {
        var _this = this;
        this.showSpinner = true;
        this.invitereq.requestTo.userDetailsId = id;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.invitereq.requestTo.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        var s2 = this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            _this.showSpinner = false;
            searchResult.invitationAction = 'Waiting for Response';
            _this.createInfoAlert("Invitation Request sent successfully!!");
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    MyConnectionsComponent.prototype.acceptconReq = function (id, searchResult) {
        var _this = this;
        this.showSpinner = true;
        var s3 = this.dashboardService.connAccept(id).subscribe(function (data) {
            console.log(data);
            searchResult.invitationAction = 'In My Network';
            searchResult.studentsCount = data.requestFrom.studentConnectionCount;
            searchResult.professorsCount = data.requestFrom.professorConnectionCount;
            searchResult.alumniCount = data.requestFrom.alumniConnectionCount;
            searchResult.ratingAction = 'SEND_RATING';
            _this.showSpinner = false;
            _this.createInfoAlert("Successfully accepted Invitation Request!!");
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    MyConnectionsComponent.prototype.ratingUser = function (searchResult) {
        var _this = this;
        if (this.rating.rating.ratingText == null || this.rating.rating.ratingText == '' || this.rating.rating.ratingText == undefined) {
            this.createInfoAlert("Please select a rating from Best/Fair/Good.");
            return;
        }
        this.showSpinner = true;
        this.rating.userResponseType = 'RATING_RESPONSE';
        console.log(this.rating);
        var s4 = this.dashboardService.rating(this.rating).subscribe(function (data) {
            console.log(data);
            _this.rating.rating.ratingText = "";
            _this.rating.responseTo.userDetailsId = '';
            searchResult.ratingAction = 'RATING_ALREADY_SENT';
            _this.showSpinner = false;
            _this.createInfoAlert("Rating submitted successfully!!");
        }, function (error) {
            _this.showSpinner = false;
            _this.rating.rating.ratingText = "";
            _this.rating.responseTo.userDetailsId = '';
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
    };
    MyConnectionsComponent.prototype.myNetworkCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.inMyNetworkFilterCriteria = "true";
        }
        else {
            this.connectionfilter.inMyNetworkFilterCriteria = "false";
            if (this.connectionfilter.isOnlyFriendsRequired == true) {
                this.connectionfilter.isOnlyFriendsRequired = false;
            }
        }
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.awaitResCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.awaitingResponseFilterCriteria = "true";
        }
        else {
            this.connectionfilter.awaitingResponseFilterCriteria = "false";
        }
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.professorsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.professors = "true";
        }
        else {
            this.connectionfilter.professors = "false";
        }
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.studentsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.students = "true";
        }
        else {
            this.connectionfilter.students = "false";
        }
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.alumniCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.alumni = "true";
        }
        else {
            this.connectionfilter.alumni = "false";
        }
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    MyConnectionsComponent.prototype.sendMssage = function (data) {
        this.viewProfile = data;
        this.msgData.usersInTo = [data.userDetailsId];
        this.sendMsg = true;
        window.scrollTo(0, 0);
    };
    MyConnectionsComponent.prototype.sendMessage = function () {
        var _this = this;
        this.showSpinner = true;
        var s7 = this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) {
            _this.sendMsg = false;
            console.log(data);
            _this.msgData = {};
            _this.showSpinner = false;
            _this.createInfoAlert("Message sent successfully !!");
        }, function (error) {
            _this.sendMsg = false;
            _this.msgData = {};
            _this.handleError(error);
        });
        this.subscriptions.push(s7);
    };
    MyConnectionsComponent.prototype.ngOnInit = function () {
        this.fnngOnInit();
        console.log(this.connectionfilter);
    };
    MyConnectionsComponent.prototype.fnngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        console.log('inside ngOnInit()');
        //reset the filter object.
        this.connectionfilter = {};
        console.log('this.connectionfilter.inMyNetworkFilterCriteria' + this.connectionfilter.inMyNetworkFilterCriteria);
        console.log('this.connectionfilter.awaitingResponseFilterCriteria' + this.connectionfilter.awaitingResponseFilterCriteria);
        console.log('this.connectionfilter.professors' + this.connectionfilter.professors);
        console.log('this.connectionfilter.students' + this.connectionfilter.students);
        console.log('this.connectionfilter.alumni' + this.connectionfilter.alumni);
        var s8 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            _this.rating.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.invitereq.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.usersummaryDone = true;
            _this.showHideLoadingSpinner();
            _this.showSpinner = false;
        }, function (error) {
            _this.showHideLoadingSpinner();
            _this.handleError(error);
        });
        this.subscriptions.push(s8);
        var s9 = this.route.queryParams.subscribe(function (params) {
            console.log('this.connectionfilter.inMyNetworkFilterCriteria' + _this.connectionfilter.inMyNetworkFilterCriteria);
            console.log('this.connectionfilter.awaitingResponseFilterCriteria' + _this.connectionfilter.awaitingResponseFilterCriteria);
            console.log('this.connectionfilter.professors' + _this.connectionfilter.professors);
            console.log('this.connectionfilter.students' + _this.connectionfilter.students);
            console.log('this.connectionfilter.alumni' + _this.connectionfilter.alumni);
            _this.connectionfilter = {};
            console.log("Finished resetting the connection filter");
            console.log('this.connectionfilter.inMyNetworkFilterCriteria' + _this.connectionfilter.inMyNetworkFilterCriteria);
            console.log('this.connectionfilter.awaitingResponseFilterCriteria' + _this.connectionfilter.awaitingResponseFilterCriteria);
            console.log('this.connectionfilter.professors' + _this.connectionfilter.professors);
            console.log('this.connectionfilter.students' + _this.connectionfilter.students);
            console.log('this.connectionfilter.alumni' + _this.connectionfilter.alumni);
            _this.query = params['s'] || 0;
            _this.uid = params['u'] || -1;
            _this.isOnlyMyConnectionsRequired = params['o'] || 'false';
            if (_this.query == '0') {
                if (_this.uid != -1) {
                    _this.connectionfilter.searchUserId = _this.uid;
                }
                var s10 = _this.loginService.country().subscribe(function (data) {
                    _this.countries = data;
                    _this.countriesDone = true;
                    _this.showHideLoadingSpinner();
                }, function (error) {
                    _this.countriesDone = true;
                    _this.showHideLoadingSpinner();
                    _this.handleError(error);
                });
                _this.subscriptions.push(s10);
                _this.getSearchData();
            }
            else {
                _this.countriesDone = true;
                _this.myConnectionsDone = true;
                if (_this.uid != -1) {
                    _this.connectionfilter.searchUserId = _this.uid;
                }
                if (_this.query == 'student') {
                    _this.connectionfilter.students = "true";
                }
                if (_this.query == 'professor') {
                    _this.connectionfilter.professors = "true";
                }
                if (_this.query == 'alumni') {
                    _this.connectionfilter.alumni = "true";
                }
                _this.getSearchData();
            }
        });
        this.subscriptions.push(s9);
    };
    MyConnectionsComponent.prototype.updateSearchResultView = function (data) {
        var _this = this;
        this.connectionfilter.inMyNetworkFilterCriteria = data.inMyNetworkFilterCriteria;
        if (data.isSearchResultEmpty) {
            this.usersummaryDone = true;
            this.countriesDone = true;
            this.myConnectionsDone = true;
            this.searchDone = true;
            this.showSpinner = false;
            this.showHideLoadingSpinner();
            this.confirmationService.confirm({
                message: "You do not have any friends in your network. Invite contacts from your Gmail account.",
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: function () {
                    _this.router.navigate(['dashboard/addconnections']);
                },
                reject: function () {
                    // do nothing
                }
            });
        }
        else {
            this.myConnection = data;
            this.myConnectionsDone = true;
            this.showHideLoadingSpinner();
            console.log(this.myConnection);
        }
    };
    MyConnectionsComponent.prototype.showSearchError = function (error) {
        this.myConnectionsDone = true;
        this.searchDone = true;
        this.showHideLoadingSpinner();
        this.handleError(error);
    };
    MyConnectionsComponent.prototype.getSearchData = function () {
        var _this = this;
        this.showSpinner = true;
        if (this.isOnlyMyConnectionsRequired == 'true') {
            this.connectionfilter.isOnlyFriendsRequired = true;
        }
        else {
            this.connectionfilter.isOnlyFriendsRequired = false;
        }
        var s12 = this.dashboardService.getMyconnections(this.connectionfilter).subscribe(function (data) {
            _this.showSpinner = false;
            _this.updateSearchResultView(data);
        }, function (error) {
            _this.showSpinner = false;
            _this.showSearchError(error);
        });
        this.subscriptions.push(s12);
    };
    MyConnectionsComponent.prototype.updateSearchResultViewWithMoreResults = function (data) {
        var _this = this;
        if (data.isSearchResultEmpty) {
            this.createInfoAlert("No more records found for selected search filters.");
        }
        else {
            data.forEach(function (element) {
                if (element.starRating > 0) {
                    element.myRatingArr = new Array(element.starRating);
                }
                _this.myConnection.push(element);
            });
            this.showSpinner = false;
        }
    };
    MyConnectionsComponent.prototype.myConnectionLoadM = function () {
        var _this = this;
        this.showSpinner = true;
        var s6 = this.dashboardService.getMyconnectionsLoadMore(this.connectionfilter).subscribe(function (data) {
            _this.updateSearchResultViewWithMoreResults(data);
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s6);
    };
    MyConnectionsComponent.prototype.onChange = function () {
        console.log(this.connectionfilter);
        this.getSearchData();
    };
    MyConnectionsComponent.prototype.showHideLoadingSpinner = function () {
        //this.showSpinner = !(this.usersummaryDone && this.countriesDone && this.myConnectionsDone && this.searchDone);
        this.showSpinner = false;
    };
    MyConnectionsComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    MyConnectionsComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    MyConnectionsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return MyConnectionsComponent;
}());
export { MyConnectionsComponent };
//# sourceMappingURL=myConnections.component.js.map